import React from 'react'
import './CountryOption.less'
import requireFlagIcon from './flags'

const CountryOption = ({key, option, selectValue, style, labelKey}) =>
  <div className='nmc-country-option' key={key} onClick={() => selectValue(option)} style={style}>
    <label>{option[labelKey]}</label>
    <img className={`${option.code}-flag`} src={requireFlagIcon(`./${option.code}.png`)} />
  </div>

export default CountryOption



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/CountriesSelect/CountryOption.js